/**
 * Display name of the Space Invader game (UI and page titles only).
 * Internal ids stay "space_invader" / "si" (routes, game keys, SDK, co-op,
 * leaderboards). Renaming the game is a one-line change here.
 * Name pending Sandesh's choice ("Void Swarm" is taken by a Steam game).
 */
export const SI_DISPLAY_NAME = 'Swarm Defense';
